// ? optional fields are specified with "null"
export default {
  travelLines: {
    defaultValues: {
      id: "",
      order: "",
      place_of_work: false,
      interval_type_id: null,
      start_place_id: null,
      end_place_id: null,
      start_time: null,
      end_time: null,
      border_crossing_time: null,
      delete: false,
      vehicle_info: null,
      attachments: [],
      distance: null,
    },
  },
};
